import { GenCodes } from './gen-codes';
import {
  DateFormatSchema,
  defaultDateValidationConfig,
} from './date-format-validator';
import {
  ContentLengthSchema,
  DoesNotHaveANumberAndRequiredSchema,
  DoesNotHaveANumberSchema,
  NumberSchema,
  SSNSchema,
} from './common-validator-schemas';
import { addressFieldValidators } from './address-validators';
import * as yup from 'yup';

// console.log(addressFieldValidations);

const monthDayCombos = ['M d', 'M dd', 'MM d', 'MM dd'];

const dayMonthCombos = ['d M', 'd MM', 'dd M', 'dd MM'];
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const fieldValueValidators: Record<string, yup.Schema<any>> = {
  account_number: ContentLengthSchema('Account_Number').min(1).required(),
  ...addressFieldValidators,
  age: ContentLengthSchema('Age').concat(NumberSchema).max(3),
  area_code1: ContentLengthSchema('Area_Code1'),
  area_code2: ContentLengthSchema('Area_Code2'),
  area_code3: ContentLengthSchema('Area_Code3'),
  dob_dd_mm_yy: ContentLengthSchema('DOB_DD_MM_YY').concat(
    DateFormatSchema(
      'DD MM YY',
      dayMonthCombos.map((a) => `${a} yy`),
      {
        ...defaultDateValidationConfig,
        formatValidationRegex:
          /^\d{1,2}\s*(-|\\|\/|\.)?\s*\d{1,2}\s*\1\s*\d{2}$/i,
      },
    ),
  ),
  dob_dd_mm_yyyy: ContentLengthSchema('DOB_DD_MM_YYYY').concat(
    DateFormatSchema(
      'DD MM YYYY',
      dayMonthCombos.map((a) => `${a} yyyy`),
      {
        ...defaultDateValidationConfig,
        formatValidationRegex:
          /^\d{1,2}\s*(-|\\|\/|\.)?\s*\d{1,2}\s*\1\s*\d{4}$/i,
      },
    ),
  ),
  dob_dd_mmm_yy: ContentLengthSchema('DOB_DD_MMM_YY').concat(
    DateFormatSchema('D MMM YY', ['d MMM yy', 'dd MMM yy'], {
      ...defaultDateValidationConfig,
      formatValidationRegex:
        /^\d{1,2}\s*(\s|-|\\|\/|\.)?\s*[a-zA-Z]{3}\s*(\1|,)\s*\d{2}$/i,
    }),
  ),
  dob_dd_mmm_yyyy: ContentLengthSchema('DOB_DD_MMM_YYYY').concat(
    DateFormatSchema('D MMM YYYY', ['d MMM yyyy', 'dd MMM yyyy'], {
      ...defaultDateValidationConfig,
      formatValidationRegex:
        /^\d{1,2}\s*(-|\\|\/|\.)?\s*[a-zA-Z]{3}\s*(\1|,)\s*\d{4}$/i,
    }),
  ),
  dob_ddmmyy: ContentLengthSchema('DOB_DDMMYY').concat(
    DateFormatSchema('DDMMYY', ['ddMMyy'], {
      ...defaultDateValidationConfig,
      formatValidationRegex: /^\d{6}$/i,
    }),
  ),
  dob_ddmmyyyy: ContentLengthSchema('DOB_DDMMYYYY').concat(
    DateFormatSchema('DDMMYYYY', ['ddMMyyyy'], {
      ...defaultDateValidationConfig,
      formatValidationRegex: /^\d{8}$/i,
    }),
  ),
  dob_mm_dd_yy: ContentLengthSchema('DOB_MM_DD_YY').concat(
    DateFormatSchema(
      'M D YY',
      monthDayCombos.map((a) => `${a} yy`),
      {
        ...defaultDateValidationConfig,
        formatValidationRegex:
          /^\d{1,2}\s*(-|\\|\/|\.)?\s*\d{1,2}\s*\1\s*\d{2}$/i,
      },
    ),
  ),
  dob_mm_dd_yyyy: ContentLengthSchema('DOB_MM_DD_YYYY').concat(
    DateFormatSchema(
      'M D YYYY',
      monthDayCombos.map((a) => `${a} yyyy`),
      {
        ...defaultDateValidationConfig,
        formatValidationRegex:
          /^\d{1,2}\s*(-|\\|\/|\.)?\s*\d{1,2}\s*\1\s*\d{4}$/i,
      },
    ),
  ),
  dob_mm_yy: ContentLengthSchema('DOB_MM_YY').concat(
    DateFormatSchema('M YY', ['MM yy', 'M yy'], {
      ...defaultDateValidationConfig,
      formatValidationRegex: /^\d{1,2}\s*(\s|-|\\|\/|\.)\s*\d{2}$/i,
    }),
  ),
  dob_mm_yyyy: ContentLengthSchema('DOB_MM_YYYY').concat(
    DateFormatSchema('M YYYY', ['MM yyyy', 'M yyyy'], {
      ...defaultDateValidationConfig,
      formatValidationRegex: /^\d{1,2}\s*(\s|-|\\|\/|\.)?\s*\d{4}$/i,
    }),
  ),
  dob_mmddyy: ContentLengthSchema('DOB_MMDDYY').concat(
    DateFormatSchema('MMDDYY', ['MMddyy'], {
      ...defaultDateValidationConfig,
      formatValidationRegex: /^\d{6}$/i,
    }),
  ),
  dob_mmddyyyy: ContentLengthSchema('DOB_MMDDYYYY').concat(
    DateFormatSchema('MMDDYYYY', ['MMddyyyy'], {
      ...defaultDateValidationConfig,
      formatValidationRegex: /^\d{8}$/i,
    }),
  ),
  dob_mmm_dd_yy: ContentLengthSchema('DOB_MMM_DD_YY').concat(
    DateFormatSchema('MMM DD YY', ['MMM dd yy', 'MMM d yy'], {
      ...defaultDateValidationConfig,
      formatValidationRegex:
        /^[a-zA-Z]{3}\s*(\s|-|\\|\/|\.)?\s*\d{1,2}\s*(\1|,)\s*\d{2}$/i,
    }),
  ),
  dob_mmm_dd_yyyy: ContentLengthSchema('DOB_MMM_DD_YYYY').concat(
    DateFormatSchema('MMM DD YYYY', ['MMM dd yyyy', 'MMM d yyyy'], {
      ...defaultDateValidationConfig,
      formatValidationRegex:
        /^[a-zA-Z]{3}\s*(\s|-|\\|\/|\.)?\s*\d{1,2}\s*(\1|,)\s*\d{4}$/i,
    }),
  ),
  dob_mmyy: ContentLengthSchema('DOB_MMYY').concat(
    DateFormatSchema('MMYY', ['MMyy'], {
      ...defaultDateValidationConfig,
      formatValidationRegex: /^\d{4}$/i,
    }),
  ),
  dob_mmyyyy: ContentLengthSchema('DOB_MMYYYY').concat(
    DateFormatSchema('MMYYYY', ['MMyyyy'], {
      ...defaultDateValidationConfig,
      formatValidationRegex: /^\d{6}$/i,
    }),
  ),
  dob_yy: ContentLengthSchema('DOB_YY').concat(
    DateFormatSchema('YY', ['yy'], {
      ...defaultDateValidationConfig,
      formatValidationRegex: /^\d{2}$/i,
    }),
  ),
  dob_yy_mm: ContentLengthSchema('DOB_YY_MM').concat(
    DateFormatSchema('YY MM', ['yy MM', 'yy M'], {
      ...defaultDateValidationConfig,
      formatValidationRegex: /^\d{1,2}(\s|-|\\|\/|\.)\d{1,2}$/i,
    }),
  ),
  dob_yy_mm_dd: ContentLengthSchema('DOB_YY_MM_DD').concat(
    DateFormatSchema(
      'YY MM DD',
      monthDayCombos.map((a) => `yy ${a}`),
      {
        ...defaultDateValidationConfig,
        formatValidationRegex:
          /^\d{2}\s*(\s|-|\\|\/|\.)?\s*\d{1,2}\s*\1\s*\d{1,2}$/i,
      },
    ),
  ),
  dob_yymm: ContentLengthSchema('DOB_YYMM').concat(
    DateFormatSchema('YYMM', ['yyMM'], {
      ...defaultDateValidationConfig,
      formatValidationRegex: /^\d{4}$/i,
    }),
  ),
  dob_yymmdd: ContentLengthSchema('DOB_YYMMDD').concat(
    DateFormatSchema('YYMMDD', ['yyMMdd'], {
      ...defaultDateValidationConfig,
      formatValidationRegex: /^\d{6}$/i,
    }),
  ),
  dob_yyyy: ContentLengthSchema('DOB_YYYY').concat(
    DateFormatSchema('YYYY', ['yyyy'], {
      ...defaultDateValidationConfig,
      formatValidationRegex: /^\d{4}$/i,
    }),
  ),
  dob_yyyy_mm: ContentLengthSchema('DOB_YYYY_MM').concat(
    DateFormatSchema('YYYY MM', ['yyyy MM', 'yyyy M'], {
      ...defaultDateValidationConfig,
      formatValidationRegex: /\d{1,4}(\s|-|\\|\/|\.)\d{1,2}/i,
    }),
  ),
  dob_yyyy_mm_dd: ContentLengthSchema('DOB_YYYY_MM_DD').concat(
    DateFormatSchema(
      'YYYY MM DD',
      monthDayCombos.map((a) => `yyyy ${a}`),
      {
        ...defaultDateValidationConfig,
        formatValidationRegex:
          /^\d{4}\s*(\s|-|\\|\/|\.)?\s*\d{1,2}\s*\1\s*\d{1,2}$/i,
      },
    ),
  ),
  dob_yyyymm: ContentLengthSchema('DOB_YYYYMM').concat(
    DateFormatSchema('YYYYMM', ['yyyyMM'], {
      ...defaultDateValidationConfig,
      formatValidationRegex: /^\d{6}$/i,
    }),
  ),
  dob_yyyymmdd: ContentLengthSchema('DOB_YYYYMMDD').concat(
    DateFormatSchema('YYYYMMDD', ['yyyyMMdd'], {
      ...defaultDateValidationConfig,
      formatValidationRegex: /^\d{8}$/i,
    }),
  ),
  first_middle_name: ContentLengthSchema('First_Middle_Name')
    .concat(DoesNotHaveANumberAndRequiredSchema)
    .min(1),
  first_name: ContentLengthSchema('First_Name')
    .concat(DoesNotHaveANumberAndRequiredSchema)
    .min(1),
  full_name_fl: ContentLengthSchema('Full_Name_FL').required().min(3),
  full_name_fml: ContentLengthSchema('Full_Name_FML').required().min(3),
  full_name_lf: ContentLengthSchema('Full_Name_FL')
    .required()
    .min(3)
    .test(
      'hasComma',
      'Should contain at least one comma.',
      (val: string) => val.split(',').length >= 2,
    ),
  full_name_lfm: ContentLengthSchema('Full_Name_LFM')
    .required()
    .min(3)
    .test(
      'hasComma',
      'Should contain at least one comma.',
      (val: string) => val.split(',').length >= 2,
    ),
  full_phone1: ContentLengthSchema('Full_Phone1'),
  full_phone2: ContentLengthSchema('Full_Phone2'),
  full_phone3: ContentLengthSchema('Full_Phone3'),
  gen_code: ContentLengthSchema('Gen_Code').trim().oneOf(GenCodes),
  last_name: ContentLengthSchema('Last_Name').required().min(2),
  middle_name: ContentLengthSchema('Middle_Name').concat(
    DoesNotHaveANumberSchema,
  ),
  name_prefix: ContentLengthSchema('First_Name').concat(
    DoesNotHaveANumberSchema,
  ),
  phone_number1: ContentLengthSchema('Phone_Number1'),
  phone_number2: ContentLengthSchema('Phone_Number2'),
  phone_number3: ContentLengthSchema('Phone_Number3'),
  ssn: ContentLengthSchema('SSN').concat(SSNSchema),
  ssn_no_zero_fill: ContentLengthSchema('SSN_No_Zero_Fill').concat(SSNSchema),
};
